import { Routes } from '@angular/router';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AuthGuard, RoleBasedGuard } from 'remarketing-angular-library';

export const sellingDisclosureRoutes: Routes = [
  {
    path: 'selling-disclosures',
    loadComponent: () => import('./components/sellingdisclosures/sellingdisclosures.component').then(c => c.SellingdisclosuresComponent),
    canActivate: [AuthGuard, AgreementsGuard, RoleBasedGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only']
    },
  },
];
